export default __webpack_public_path__ + "static/media/instructor.61dc8ae2.svg";